import { zodResolver } from '@hookform/resolvers/zod'
import { useForm, UseFormProps } from 'react-hook-form'
import { z } from 'zod'

import { makeGenericZodErrorMessage } from '@/utils/make-generic-zod-error-message'

const schemaWithRegion = z.object({
  calendar_diagnosis: z.object(
    {
      name: z
        .string(
          makeGenericZodErrorMessage(
            'A seleção de um novo diagnóstico ou pré-cadastro é obrigatória.',
          ),
        )
        .min(
          1,
          'A seleção de um novo diagnóstico ou pré-cadastro é obrigatória.',
        ),
      id: z
        .string(
          makeGenericZodErrorMessage(
            'A seleção de um novo diagnóstico ou pré-cadastro é obrigatória.',
          ),
        )
        .min(
          1,
          'A seleção de um novo diagnóstico ou pré-cadastro é obrigatória.',
        ),
      culture: z.enum(['cane', 'soybean', 'corn']).optional(),
      treatment: z.enum(['planting_failure', 'weed', 'physiology']).optional(),
      date: z.string().optional(),
    },
    makeGenericZodErrorMessage(
      'A seleção de um novo diagnóstico ou pré-cadastro é obrigatória.',
    ),
  ),
  project: z.object(
    {
      name: z
        .string(
          makeGenericZodErrorMessage('A seleção do projeto é obrigatória.'),
        )
        .min(1, 'A seleção do projeto é obrigatória.'),
      id: z
        .number(
          makeGenericZodErrorMessage('A seleção do projeto é obrigatória.'),
        )
        .min(1, 'A seleção do projeto é obrigatória.'),
    },
    makeGenericZodErrorMessage('A seleção do projeto é obrigatória.'),
  ),
  region: z.object(
    {
      name: z
        .string(
          makeGenericZodErrorMessage('A seleção da região é obrigatória.'),
        )
        .min(1, 'A seleção da região é obrigatória.'),
      id: z
        .number(
          makeGenericZodErrorMessage('A seleção da região é obrigatória.'),
        )
        .min(1, 'A seleção da região é obrigatória.'),
    },
    makeGenericZodErrorMessage('A seleção da região é obrigatória.'),
  ),
  treatment: z.enum(
    ['planting_failure', 'weed', 'physiology'],
    makeGenericZodErrorMessage('A seleção do diagnóstico é obrigatória.'),
  ),
  image_type: z.enum(
    ['raw_images_geotag', 'raw_images', 'mosaic'],
    makeGenericZodErrorMessage('A seleção do tipo de imagem é obrigatória.'),
  ),
  demand_name: z
    .string()
    .min(1, 'O nome do diagnóstico é obrigatório.')
    .max(45, 'O nome do diagnóstico deve ter no máximo 45 caracteres.'),
  culture: z.enum(
    ['cane', 'soybean', 'corn'],
    makeGenericZodErrorMessage('A seleção da cultura é obrigatória.'),
  ),
  flight_date: z.coerce
    .date(makeGenericZodErrorMessage('A data do voo é obrigatória.'))
    .min(new Date('1900-01-01'), { message: 'Data muito antiga.' })
    .max(new Date(), { message: 'Data futura.' })
    .transform((value) => value.toJSON().split('T')[0]),
})

const schemaWithoutRegion = schemaWithRegion.omit({ region: true })

export type DefaultRegisterFormData = z.infer<typeof schemaWithRegion>

const getSchema = (hasRegion: boolean) => {
  return hasRegion ? schemaWithRegion : schemaWithoutRegion
}

export const useRegisterForm = (
  hasRegion: boolean,
  props?: UseFormProps<DefaultRegisterFormData>,
) => {
  const schema = getSchema(hasRegion)

  const methods = useForm<DefaultRegisterFormData>({
    resolver: zodResolver(schema),
    ...props,
  })

  return methods
}
